import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=16e7f02d&scoped=true&"
import script from "./Details.vue?vue&type=script&lang=ts&"
export * from "./Details.vue?vue&type=script&lang=ts&"
import style0 from "./Details.vue?vue&type=style&index=0&id=16e7f02d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e7f02d",
  null
  
)

export default component.exports